import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { IconPropsInterface } from './Icon.types';

interface $SvgProps {
  $width?: string;
  $height?: string;
  $color: string;
}

const $Svg = styled.svg<$SvgProps>`
  width: ${({ $width }) => $width ?? 'auto'};
  height: ${({ $height }) => $height ?? 'auto'};
  transition: fill 100ms ease-out;

  & {
    color: ${({ $color }) => $color};
  }
`;

const formatDimension = (value?: string | number) => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (typeof value === 'number') {
    return `${value}px`;
  }

  return value;
};

const Icon = forwardRef<SVGSVGElement, IconPropsInterface>(function Icon(
  {
    children,
    width,
    height,
    size = rem(12),
    viewBox = '0 0 24 24',
    color,
    fill = 'none',
    ...rest
  },
  ref,
) {
  const { colors = { primary: 'black' } } = useTheme() || {};
  const { primary = 'black' } = colors;
  const colorToApply = color || primary;

  return (
    <$Svg
      ref={ref}
      viewBox={viewBox}
      $width={formatDimension(width ?? size)}
      $height={formatDimension(height ?? size)}
      $color={colorToApply}
      fill={fill}
      {...rest}
    >
      {children}
    </$Svg>
  );
});

export default Icon;
